var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('railway-tours-list-popup',{ref:"railwayToursListPopup",attrs:{"railwayTourItems":_vm.railwayTourItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }